import { FaEnvelope } from 'react-icons/fa';
import { IoLocationSharp } from "react-icons/io5";
import { IoIosArrowForward } from "react-icons/io";
import logo from "../assets/imagenes/logo_medical_negro.png";

const Footer = () => {
  return (
    <footer className="text-center text-lg-start" style={{ backgroundColor: '#171717', color: '#ffffffff'}}>
      <section className="">
        <div className="container text-center text-md-start mt-5">
          <div className="row mt-3">
            <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
              <img
                src={logo}
                alt="MEDICAL ASSISTANT"
                style={{
                height: 'auto',
                maxHeight: '70px',
                width: 'auto',
                marginBottom: '15px',
                }}
                className="navbar-brand"
              />
              <p>
                Medical Assistant es una plataforma que se enfoca en en monitoreo y gestión de la salud laboral, optimizando el bienestar de los empleados y mejorando la productividad empresarial.
              </p>
            </div>
            <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
              <h3 className="mb-4" style={{fontWeight: '400'}}>
                Servicios
              </h3>
              <p>
                <IoIosArrowForward className="me-3"/>Monitoreo de Salud
              </p>
              <p>
                <IoIosArrowForward className="me-3"/>Gestión de Bienestar
              </p>
              <p>
                <IoIosArrowForward className="me-3"/>Evaluación de Salud
              </p>
              <p>
                <IoIosArrowForward className="me-3"/>Evaluaciones de Salud
              </p>
              <p>
                <IoIosArrowForward className="me-3"/>Reportes de Salud
              </p>
            </div>
            <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
              {/* Links */}
              <h3 className="mb-4" style={{fontWeight: '400'}}>Contáctanos</h3>
              <p>
                <IoLocationSharp className="me-3" />San Borja, Lima, Perú
              </p>
              <p>
                <FaEnvelope className="me-3" />desarrollo@im-ra.com
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="text-center p-4" style={{ backgroundColor: '#212121' }}>
        © {new Date().getFullYear()}
        <a className="text-reset" style={{ textDecoration: 'none' }}> Medical Assistant</a>
      </div>
    </footer>
  );
};

export default Footer;